import Axios from "axios";
import Url from "app/shared/constants/Url";
const FetchUnitList = async(page, search = "") => {
    let URL = Url.costMaster.unitList;
    let userId = localStorage.getItem("userId");
    let token = localStorage.getItem("springToken");
    const requestParams = {
      auth_key: token,
      user_id: userId,
      
    };
     
    
    try {
        const response = await Axios.get(`${URL}`,{
          params:requestParams,
          headers: {
            'accept': 'application/json',
            'Content-Type': 'multipart/form-data'  
          }
        });
        console.log(response,"response")
        if (response.status === 200) {
            return response.data;
          }        
      } catch (error) {
        console.error("Error fetching units", error.response?.data || error.message);
        throw error;
      } 
};

export default FetchUnitList;